<template>
  <div class="relative">
    <input
      type="number"
      :class="['Input text-right pl-4 pr-8 py-2 w-full border outline-none rounded-md text-gray-600', { 'border-red-600 text-red-600': isInvalid }]"
      @input="$emit('update:modelValue', Number($event.target.value))"
      :value="modelValue"
      :id="id"
    >
    <label :for="id" :class="['absolute top-2 right-3 text-gray-600', { 'text-red-600': isInvalid }]">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Number,
    label: String,
    isInvalid: Boolean,
    id: String
  }
}
</script>

<style>
.Input {
  -moz-appearance: textfield;
}

.Input::-webkit-outer-spin-button,
.Input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>